/**
 * True at the desktop frame's breakpoint (`lg`, 1024px) — for pages whose
 * desktop and phone layouts are separate components (the MDM-style desktop
 * pages), so only ONE of them mounts and fetches. Without `matchMedia`
 * (jsdom, very old browsers) it answers false: the phone layout, which is the
 * one every existing test was written against.
 */
import { useSyncExternalStore } from "react";

const QUERY = "(min-width: 1024px)";

function subscribe(onChange: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mq = window.matchMedia(QUERY);
  mq.addEventListener?.("change", onChange);
  return () => mq.removeEventListener?.("change", onChange);
}

function snapshot(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
